module.exports = __webpack_public_path__ + "img/phone.61304e05.png";